import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, Copy, Box } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from './SpecialOfferCard.styles';
const AccordionTitle = themeStyles.apply(Copy, 'AccordionTitle');
const AccordionBodyWrapper = themeStyles.apply(Box, 'AccordionBodyWrapper');
const LegalInfoAccordion = ({ legal }) => {
    const content = [
        {
            key: 'motors',
            title: (_jsx(AccordionTitle, { styling: "primary", size: "legal", children: legal === null || legal === void 0 ? void 0 : legal.title })),
            content: (_jsx(AccordionBodyWrapper, { children: legal === null || legal === void 0 ? void 0 : legal.sections.map(section => (_jsxs(Copy, { size: "legal", children: [section.order, " ", section.text] }, section.text))) })),
        },
    ];
    return (_jsx(Accordion, { items: content, iconName: "animatedArrowUpDown", borderColor: "transparent", panelBackgroundColor: "grey.4" }));
};
export default LegalInfoAccordion;
